
const MIN_FONT_SIZE = 6;
const MAX_FONT_SIZE = 40;

export {
  MIN_FONT_SIZE,
  MAX_FONT_SIZE
}